import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from '@mui/material'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { ArrowBack } from '@mui/icons-material'
import MaterialTypography from '../../../components/MaterialTypography'
import { useNavigate, useSearchParams } from 'react-router-dom'
import MaterialBox from '../../../components/MaterialBox'
import MaterialSelect from '../../../components/MasterSelect'
import { useBodyStyleFormHandling } from "./components/BodyStyleStateHandle.js"
import { useEffect, useState } from 'react'
import MaterialInput from '../../../components/MaterialInput/index.js'
import { fetchData, fetchDataById, postData, putData } from '../../../services/index.js'
import MaterialButton from '../../../components/MaterialButton/index.js'
import { useLoading } from '../../../components/Loading/index.js'
import { useSnackbar } from '../../../context/popup.js'

const InsurerBodyStyleForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
    const bodyStyleId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" 
        ? "edit" : "add";
    const [generalInsurerOptions, setGeneralInsurerOptions] = useState([]);
    const [motorBodyStyleOptions, setMotorBodyStyleOptions] = useState([]);
    const [insurerBodyTypeOptions, setInsurerBodyTypeOptions] = useState([]);

    useEffect(() => {
        if (pageMode === "add" || !bodyStyleId) {
            return;
        }
        //Fetch data by Pincode Id
        const fetchBodyTypeById = async (bodyStyleId) => {
            setCircleLoading(true);
            try {
            const response = await fetchDataById(`/reference/insurer/body-style/${bodyStyleId}`);

            const responseData = response?.data?.bodyStyle;
            
            if (response.success) {
                const mapped = {
                    name: responseData?.name || "",
                    code: responseData?.code || "",
                    mBodyStyle: { label :responseData?.mBodyStleName, value: responseData?.mBodyStyleId },
                    gInsurer: { label: responseData?.gInsurerName, value: responseData?.gInsurerId },
                    iBodyType: { label: responseData?.iBodyTypeId, value: responseData?.iBodyTypeId },
                    isActive: responseData?.isActive,
                    // reset status fields
                    nameStatus: responseData?.name ? "success" : "unchecked",
                    codeStatus: responseData?.code ? "success" : "unchecked",
                    mBodyStyleStatus: responseData?.mBodyStyleId ? "success" : "unchecked",
                    gInsurerStatus: responseData?.gInsurerId ? "success" : "unchecked",
                    iBodyTypeStatus: responseData?.iBodyTypeId ? "success" : "unchecked",
                };

                setFormData(mapped);  
            }
            } catch (error) {
            console.error("Error fetching data by ID:", error);
            showSnackbar(error?.response?.data?.message, "error");
            }
            finally{
                setCircleLoading(false);
            }
        };
        fetchBodyTypeById(bodyStyleId);
    }, [pageMode]);

    useEffect(() => {
        if(pageMode === "view"){
            return
        }
        fetchAllDropdowns();
    }, []);

    //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);

        try {
            const [
            insurerResponse,
            bodyStyleResponse,
            bodyTypeResponse,
            ] = await Promise.all([
            fetchData(`/reference/general/insurer-master?dropdown=true&isActive=true`),
            fetchData(`/reference/motor/bodystyles?dropdown=true&isActive=true`),
            fetchData(`/reference/insurer/body-type?dropdown=true&isActive=true`),
            ]);

            const formattedInsurers = insurerResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.companyName,
            })) || [];

            const formattedBodyStyles = bodyStyleResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.name,
            })) || [];

            const formattedBodyTypes = bodyTypeResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.name,
            })) || [];
            
            setGeneralInsurerOptions(formattedInsurers);
            setMotorBodyStyleOptions(formattedBodyStyles);
            setInsurerBodyTypeOptions(formattedBodyTypes)

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error fetching dropdown data", "warning");
        } finally {
            setCircleLoading(false);
        }
    };

    //post and put api function
    const handleSubmitBodyStyle = async () => {
        const payload = {
            // id: bodyStyleId,      //id to be uncommented when updating
            gInsurerId: formData?.gInsurer?.value,
            mBodyStyleId: formData?.mBodyStyle?.value,
            iBodyTypeId: formData?.iBodyType?.value,
            name: formData?.name,
            code: formData?.code,
            isActive: formData?.isActive,
        };
        //Update
        if(bodyStyleId){
            try {
                const response = await putData(`/reference/insurer/body-style/${bodyStyleId}`, payload);
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage,"success");
                    navigate('/insurer-master/body-style');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage,"error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message, "error");
            }
        }
        else{      
        //Submit
            try {
                const response = await postData('/reference/insurer/body-style', payload);
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage,"success");
                    navigate('/insurer-master/body-style');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage,"error")
                }
            } catch (error) {
                console.error('Error posting data:', error);
                //catch error message
                showSnackbar(error?.response?.data?.message, "error");
            }
        }
    };

    const { formData, setFormData, handleChange, checkAllFields } = useBodyStyleFormHandling();      
    
  return (
    <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
            <CardHeader
            title={(
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton onClick={() => navigate("/insurer-master/body-style")}>
                            <ArrowBack />
                        </IconButton>
                        <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            Body Style Details
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            Enter New Body Style Details to Insurer.
                        </MaterialTypography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
            />
            <CardContent>
                <Grid2 container spacing={2}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Insurer*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gInsurer"
                        value={formData.gInsurer}
                        onChange={handleChange}
                        options={generalInsurerOptions}
                        success={formData.gInsurerStatus === "success"}
                        error={formData.gInsurerStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Motor Body Style*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="mBodyStyle"
                        value={formData.mBodyStyle}
                        onChange={handleChange}
                        options={motorBodyStyleOptions}
                        success={formData.mBodyStyleStatus === "success"}
                        error={formData.mBodyStyleStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Insurer Body Type*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="iBodyType"
                        value={formData.iBodyType}
                        onChange={handleChange}
                        options={insurerBodyTypeOptions}
                        success={formData.iBodyTypeStatus === "success"}
                        error={formData.iBodyTypeStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Body Style Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        success={formData.nameStatus === "success"}
                        error={formData.nameStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.nameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Body Style Name should be a minimum 1 character & maximum 100
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Body Style Code*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        success={formData.codeStatus === "success"}
                        error={formData.codeStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.codeStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Body Style Code should be a minimum 1 character & maximum 20
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Active
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.isActive}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "isActive",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.isActive ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
            <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            >
                {pageMode !== "view" && (
                <>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="outlined"
                    color="dark"
                    onClick={() => navigate("/insurer-master/body-style")}
                    >
                    Cancel
                    </MaterialButton>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleSubmitBodyStyle}
                    >
                    {pageMode === "edit" ? "Update" : "Submit"}
                    </MaterialButton>
                </>
                )}
            </MaterialBox>
        </Card>
    </DashboardLayout>
  )
}

export default InsurerBodyStyleForm